export default __webpack_public_path__ + "static/media/eb-pro-blk-3.219188f2.png";